import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import CATALOG from '../data/catalog';

const CategorySelection = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const gender = location.state?.gender || 'female';

  const genderKey = gender === 'male' ? 'male' : 'female';
  const catData = CATALOG[genderKey] || {};

  const categories = Object.entries(catData).map(([id, data]) => {
    const minPrice = Math.min(...data.products.map(p => p.price));
    const firstImage = data.products[0]?.image || '';
    return { id, name: data.name, price: `₹${minPrice.toLocaleString('en-IN')}`, image: firstImage, count: data.products.length };
  });

  const handleCategoryClick = (category) => {
    navigate('/product-catalog', { state: { gender, category: category.id } });
  };

  return (
    <div data-testid="category-selection" className="min-h-screen flex flex-col"
      style={{ backgroundColor: '#FAF9F6', fontFamily: 'Outfit, sans-serif' }}>
      <div className="sticky top-0 z-50 flex items-center justify-between px-4 py-4 border-b"
        style={{ backgroundColor: 'rgba(250, 249, 246, 0.9)', backdropFilter: 'blur(12px)', borderColor: '#E5E5E5' }}>
        <button data-testid="back-btn" onClick={() => navigate(-1)} className="p-2 -ml-2">
          <ChevronLeft className="w-6 h-6" style={{ color: '#0F0F0F' }} strokeWidth={1.5} />
        </button>
        <h1 className="text-lg" style={{ fontFamily: 'Playfair Display, serif', color: '#0F0F0F' }}>
          {gender === 'female' ? 'Women' : 'Men'}'s Collection
        </h1>
        <div className="w-10" />
      </div>

      <div className="flex-1 grid grid-cols-2 gap-[1px]" style={{ backgroundColor: '#E5E5E5' }}>
        {categories.map((category) => (
          <button key={category.id} data-testid={`category-${category.id}`}
            onClick={() => handleCategoryClick(category)}
            className="relative overflow-hidden group bg-white" style={{ aspectRatio: '3/4' }}>
            <div className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-110"
              style={{ backgroundImage: `url(${category.image})` }} />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-4 text-left">
              <h3 className="text-lg text-white mb-0.5" style={{ fontFamily: 'Playfair Display, serif' }}>{category.name}</h3>
              <p className="text-xs text-white/70">From {category.price} {'\u2022'} {category.count} designs</p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default CategorySelection;
